/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  hashSections,
  labels,
  notificationPosition,
  notificationSetting,
  notificationType,
  routesList,
  showNotification,
} from "../Common";
import { CountDownTimer } from "./CountDownTimer";
import {
  connectWallet,
  getcurrentlyConnectChain,
  getcurrentlyConnectWallet,
  getWalletChangingDetails,
  totalValues,
} from "../Scripts/interact";

const Header = () => {
  const [form, setForm] = useState({});
  const [message, setMessage] = useState("");
  const [wallet, setWallet] = useState({
    address: null,
    balance: null,
    chainId: null,
  });
  const [walletConnected, setWalletConnected] = useState(false);
  const [timerOff, setTimerOff] = useState(false);
  const [openSeaClass, setOpenSeaClass] = useState("assets/images/opensea.png");
  const history = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const getAndSetWalletData = async () => {
      const { status, message, address, walletBalance, chainId } =
        await getcurrentlyConnectWallet();

      if (status) {
        setWalletConnected(true);
      } else {
        setWalletConnected(false);
        if (window.location.pathname === routesList.mint) {
          navigate(routesList.homePage);
        }
      }
      setWallet(() => {
        return { address: address, balance: walletBalance, chainId: chainId };
      });
      setMessage(message);

      monitorWalletChange();
      await getcurrentlyConnectChain();

      let response = await totalValues();
      if (response?.total && Object.keys(response?.total).length > 0) {
        if (
          parseInt(response?.total.maxMints) ===
          parseInt(response?.total.totalRemaining)
        ) {
          setTimerOff(true);
        }
      }
    };
    getAndSetWalletData().catch(console.error);
  }, [wallet.address]);

  useEffect(() => {
    window.toggleNavBar();
  }, []);

  const monitorWalletChange = async () => {
    const { ethereum } = window;
    if (ethereum) {
      try {
        const connectAddresses = await ethereum.on(
          "accountsChanged",
          (accounts) => {
            if (accounts.length > 0) {
              setMessage(`Current Wallet is ${accounts[0]}`);
              setWallet(() => {
                return { address: accounts[0], balance: null, chainId: null };
              });
            } else {
              setMessage(
                "Connect to MetaMask by Clicking 'Connect to Wallet' Button"
              );
              setWallet({});
            }
          }
        );
        // console.log("Selected Address: ", connectAddresses?.selectedAddress);
      } catch (error) {
        return {
          status: false,
          address: "",
          message: error.message,
        };
      }
    } else {
      return {
        status: false,
        address: "",
        message: (
          <span>
            <p>
              {" "}
              🦊{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://metamask.io/download.html`}
              >
                You must install Metamask, a virtual Ethereum wallet, in your
                browser.
              </a>
            </p>
          </span>
        ),
      };
    }
  };

  const connectWalletPressed = async () => {
    const response = await connectWallet();

    if (response.status) {
      setWalletConnected(true);
    } else {
      setWalletConnected(false);
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
    setMessage(response.message);
    setWallet({
      address: response.address,
      balance: response.walletBalance,
      chainId: response.chainId,
    });
  };

  const appendActiveClass = (path) => {
    if (history && history.pathname === path) {
      return ` active`;
    }
    return ``;
  };

  return (
    <>
      <header>
        {/* {timerOff && (
          <div className="stripmint" id="stripmint">
            <span>SOLD OUT</span>
            <CountDownTimer
              isTimerOff={(value) => {
                setTimerOff(value);
              }}
            />
          </div>
        )} */}
        <div className="container">
          <nav className="navbar navbar-expand-xl navbar-light">
            <a
              className={`nav-link closeSideBar${appendActiveClass(
                routesList.homePage
              )}`}
              aria-current="page"
              href={routesList.homePage}
            >
              <img className="logo" src="assets/images/logo.png" alt="" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <button
                className="navbar-toggler collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                &times;
              </button>
              <ul className="navbar-nav ms-auto ">
                <li className="nav-item">
                  <a
                    className={`nav-link closeSideBar${appendActiveClass(
                      routesList.homePage
                    )}`}
                    aria-current="page"
                    href={routesList.homePage}
                  >
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link closeSideBar"
                    href={hashSections.aboutUs}
                  >
                    About us
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link closeSideBar"
                    href={hashSections.roadmap}
                  >
                    Roadmap
                  </a>
                </li>
                {/* <li className="nav-item">
                  <Link
                    className={`nav-link closeSideBar${appendActiveClass(
                      routesList.utilities)}`} 
                    to={routesList.utilities}
                  >
                    {labels.utilities}
                  </Link>
                </li>  */}
                <li className="nav-item">
                  <a className="nav-link closeSideBar" href={hashSections.team}>
                    Team
                  </a>
                </li>
                <li className="nav-item social-icon-top">
                  <a
                    href={"https://twitter.com/SuperCreatorNFT"}
                    target="_blank"
                    className="closeSideBar"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href={"https://discord.gg/2XGJMR7sfw"}
                    target="_blank"
                    className="closeSideBar"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                  <a
                    href={"https://opensea.io/collection/supercreatorsorigins"}
                    target="_blank"
                    className="closeSideBar opensea"
                    onMouseEnter={() =>
                      setOpenSeaClass("assets/images/opensea-hover.png")
                    }
                    onMouseLeave={() =>
                      setOpenSeaClass("assets/images/opensea.png")
                    }
                  >
                    <img src={openSeaClass} alt="" />
                  </a>
                  <a
                    href={"https://www.instagram.com/iamverseofficial/"}
                    target="_blank"
                    className="closeSideBar opensea"
                  >
                    <i className="bi bi-instagram"></i>
                  </a>
                </li>
                <li className="nav-item dropdown ">
                  <a
                    className="nav-link btn dropdown-toggle clickable"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Token Holders
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    {parseInt(
                      process.env.REACT_APP_BABY_MINTING_BUTTON_DISPLAY
                    ) === 1 && (
                      <li className="nav-item wallet">
                        <Link
                          className="closeSideBar" //onClick={mintNFT}>
                          to={routesList.baby_mint}
                        >
                          {labels.baby_mint}
                        </Link>
                      </li>
                    )}
                    {parseInt(
                      process.env.REACT_APP_SUPER_BABY_MINTING_BUTTON_DISPLAY
                    ) === 1 && (
                      <li className="nav-item wallet ">
                        <Link
                          className="closeSideBar" //onClick={mintNFT}>
                          to={routesList.super_baby_mint}
                        >
                          {labels.super_baby_mint}
                        </Link>
                      </li>
                    )}
                    {parseInt(
                      process.env.REACT_APP_TOKEN_HOLDER_BUTTON_DISPLAY
                    ) === 1 && (
                      <li className="nav-item wallet">
                        <Link
                          className="closeSideBar" //onClick={mintNFT}>
                          to={routesList.token_holder}
                        >
                          {labels.token_holder_area}
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>

                {/* {parseInt(process.env.REACT_APP_BABY_MINTING_BUTTON_DISPLAY) ===
                  1 && (
                  <li className="nav-item wallet me-2">
                    <Link
                      className="btn closeSideBar" //onClick={mintNFT}>
                      to={routesList.baby_mint}
                    >
                      <img
                        src="assets/images/baby.png"
                        alt="Baby Mint"
                        title=""
                        className="babymint-icon me-2"
                      />
                      {labels.baby_mint}
                    </Link>
                  </li>
                )}
                {parseInt(process.env.REACT_APP_TOKEN_HOLDER_BUTTON_DISPLAY) ===
                  1 && (
                  <li className="nav-item wallet">
                    <Link
                      className="btn closeSideBar" //onClick={mintNFT}>
                      to={routesList.token_holder}
                    >
                      {labels.token_holder_area}
                    </Link>
                  </li>
                )} */}

                {/* <li className="nav-item wallet">
                  {window.location.pathname === routesList.homePage && (
                    <Link
                      className="btn closeSideBar" //onClick={mintNFT}>
                      to={routesList.token_registration}
                    >
                      {labels.token_registration}
                    </Link>
                  )}
                  {!walletConnected ? (
                    <button
                      type="button"
                      className="btn closeSideBar"
                      onClick={connectWalletPressed}
                    >
                      {labels.connect_wallet}
                    </button>
                  ) : (
                    <Link
                      className="btn closeSideBar" //onClick={mintNFT}>
                      to={routesList.mint}
                    >
                      {labels.mint}
                    </Link>
                  )}
                </li> */}
              </ul>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
